import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
// import { Button } from '@hvcgroep/design-system';

const WysiwygField = ({ html, ...props }) => {
  const parsedHtml = ReactHtmlParser(html, {
    transform: (node) => {
      switch (node.name) {
        // case 'a': {
        //   if (node.attribs.class && node.attribs.class.split(' ').indexOf('button') !== -1) {
        //     const label = node.children[0].data;
        //     return (
        //       <Button primary key={`${node.name}:${label}`}>
        //         {label}
        //       </Button>
        //     );
        //   }
        //   break;
        // }

        default: {
          break;
        }
      }
    },
  });

  return (
    <div className="WysiwygField" {...props}>
      {parsedHtml}
    </div>
  );
};

PropTypes.propTypes = {
  html: PropTypes.string.isRequired,
};

export default WysiwygField;
